"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GoogleMapsComponent;
var _googleMapReact = _interopRequireDefault(require("google-map-react"));
var _lodash = require("lodash");
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var GoogleMapMarker = _ref => {
  var {
    place
  } = _ref;
  var geoCityState = _.filter([place.state, place.zip]).join(' ');
  var geoAddress = _.filter([place.address1, place.city, geoCityState]).join(', ');
  var streetAddress = _.filter([place.address1, place.address2, place.address3]).join(', ');
  var cityStateZip = _.filter([place.city, geoCityState]).join(', ');
  var popover = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, {
    id: "popover-basic"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover.Header, null, /*#__PURE__*/_react.default.createElement("h4", null, place.agencyName)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover.Body, null, /*#__PURE__*/_react.default.createElement("p", null, streetAddress, /*#__PURE__*/_react.default.createElement("br", null), cityStateZip), /*#__PURE__*/_react.default.createElement("a", {
    href: "//www.google.com/maps?q=".concat(geoAddress),
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-external-link"
  }), " \xA0 Directions")));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    trigger: "click",
    placement: "auto",
    overlay: popover,
    defaultShow: false
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-map-pin-fill",
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Info Popover"))));
};
function GoogleMapsComponent(props) {
  var defaultProps = {
    zoom: 11
  };
  var mapCenterLocation = (0, _lodash.get)(props.mapCenterLocation, 'geometry.location');

  // Fit map to its bounds after the api is loaded
  var apiIsLoaded = (map, maps, places) => {
    // Get bounds by our places
    var bounds = new maps.LatLngBounds();
    places.forEach(place => {
      bounds.extend(new maps.LatLng(place.latitude, place.longitude));
    });
    // Fit map to bounds
    map.fitBounds(bounds);
  };
  var OPTIONS = {
    minZoom: 3,
    maxZoom: 18,
    fullscreenControl: false
  };
  return (
    /*#__PURE__*/
    // Important! Always set the container height explicitly
    _react.default.createElement("div", {
      style: {
        height: '50vh',
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(_googleMapReact.default, {
      bootstrapURLKeys: {
        key: props.mapCenterLocation.googleKey
      },
      center: mapCenterLocation,
      defaultZoom: defaultProps.zoom,
      yesIWantToUseGoogleMapApiInternals: true,
      onGoogleApiLoaded: _ref2 => {
        var {
          map,
          maps
        } = _ref2;
        return apiIsLoaded(map, maps, props.agencyArray);
      },
      options: OPTIONS
    }, (0, _lodash.map)(props.agencyArray, eachAgency => {
      var source = eachAgency;
      return /*#__PURE__*/_react.default.createElement(GoogleMapMarker, {
        key: eachAgency._id,
        lat: source.latitude,
        lng: source.longitude,
        place: source
      });
    })))
  );
}